import { render } from "./FAB.vue?vue&type=template&id=1d743d00"
import script from "./FAB.vue?vue&type=script&lang=js"
export * from "./FAB.vue?vue&type=script&lang=js"

import "./FAB.vue?vue&type=style&index=0&id=1d743d00&lang=scss"
script.render = render

export default script